import { render, staticRenderFns } from "./recycle_bin.vue?vue&type=template&id=3a4bced4&scoped=true&"
import script from "./recycle_bin.vue?vue&type=script&lang=js&"
export * from "./recycle_bin.vue?vue&type=script&lang=js&"
import style0 from "./recycle_bin.vue?vue&type=style&index=0&id=3a4bced4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4bced4",
  null
  
)

export default component.exports